import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';

const Cart = () => {
  const { items, removeItem, updateQuantity, getTotal, clearCart } = useCart();

  if (items.length === 0) {
    return (
      <section className="cart">
        <h2>SHOPPING CART</h2>
        <p>Your cart is empty</p>
      </section>
    );
  }

  return (
    <section className="cart">
      <h2>SHOPPING CART</h2>
      <div className="cart-items">
        {items.map((item) => (
          <div key={item.id} className="cart-item">
            <div className="cart-item-info">
              <h3>{item.label}</h3>
              <p className="cart-item-ref">Ref: {item.ref}</p>
              <p className="cart-item-price">£{item.price_ttc.toFixed(2)} each</p>
            </div>
            <div className="cart-item-controls">
              <div className="quantity-controls">
                <button
                  onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  className="quantity-btn"
                >
                  -
                </button>
                <span className="quantity">{item.quantity}</span>
                <button
                  onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  className="quantity-btn"
                  disabled={item.quantity >= item.stock}
                >
                  +
                </button>
              </div>
              <div className="cart-item-total">
                £{(item.price_ttc * item.quantity).toFixed(2)}
              </div>
              <button
                onClick={() => removeItem(item.id)}
                className="remove-btn"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="cart-summary">
        <div className="cart-total">
          <strong>Total: £{getTotal().toFixed(2)}</strong>
        </div>
        <div className="cart-actions">
          <button onClick={clearCart} className="btn clear-cart-btn">
            Clear Cart
          </button>
          <Link to="/checkout" className="btn checkout-btn">
            Proceed to Checkout
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Cart;
